// One setting row for admin cards (Poll, Quiz): label + short help on the left,
// the control (switch, radio group, button) on the right.
export function SettingRow({ label, help, children }) {
  return (
    // Label-only rows are a little tighter than rows with help text.
    <div className={`flex items-center justify-between gap-3 px-3.5 ${help ? "py-2.5" : "py-2"}`}>
      <div className="min-w-0">
        <p className="text-xs font-semibold text-gray-800">{label}</p>
        {help && <p className="text-[11px] text-gray-500 truncate">{help}</p>}
      </div>
      <div className="shrink-0">{children}</div>
    </div>
  );
}

export default SettingRow;
